
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  components: {},
  computed: {
    ...mapState('globals', ['user']),
    ...mapState('dailyChallenges', ['problem']),
  },
})
export default class DailyChallengeSubscribePremium extends Vue {}
